import React, { useState, useEffect } from 'react';

//Components
import FichaDestino from './FichaDestino';
import NovoDestino from './NovoDestino';
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';

//Api
import destino_api from '../../../api/destino_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { getSessionCookie } from '../../../helpers/cookies';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

// Context
import { useAuth } from '../../../context/auth';


export default function Destinos({ permissao }) {
    const { setupVariavel } = useAuth();

    //Guarda a lista de destinos
    const [destinos, setDestinos] = useState([]);

    //Estado de controle para visualização da ficha
    const [detalhes, setDetalhes] = useState(null);

    //Estado de controle para a tela de novo destino
    const [novo, setNovo] = useState(false);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Função de botão visualizar da tabela
    const visualizar = (item) => {
        setDetalhes(item.id);
    }

    //Variavel que guarda as ações da tabela
    const actions = [actionsTable.visualizar(visualizar)];

    //Carrega a lista de destinos
    const loadDestinos = () => {
        setLoading(true);
        destino_api.GetList().then(response => {
            setDestinos(response.data);
            setLoading(false);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
            setLoading(false);
        })
    }

    //Dados do usuario logado
    const usuario = getSessionCookie();


    useEffect(() => {
        loadDestinos();
    }, []);

    //Cabeçalhos da tabela de destinos
    const headers = [
        { value: "Fantasia", objectValue: "fantasia", align: "left" },
        { value: "Razão Social", objectValue: "razao", align: "left" },
        { value: "CNPJ", objectValue: "cnpj", align: "left" },
    ]

    //Carrega o componente da ficha se o estado de detalhes tiver algo
    if (detalhes != null) {
        return (
            <>
                <FichaDestino btnVoltar={() => {
                    loadDestinos();
                    setDetalhes(null);
                }} id={detalhes} permissao={permissao} integracaoCadastros={setupVariavel?.integracaoCadastros} />
            </>
        )
    }

    //Carrega o componente de novo destino se o estado de novo estiver ativo
    if (novo) {
        return (
            <>
                <NovoDestino btnVoltar={() => {
                    loadDestinos();
                    setNovo(false);
                }} />
            </>
        )
    }
    return (
        <>
            {
                loading && <Loading />
            }
            <MainCard noCard btnCadastro={permissao === "Editar" && !setupVariavel?.integracaoCadastros ? "Adicionar" : null} onClickBtnCadastro={() => setNovo(true)} >
                <div className='mt-4'>
                    <TabelaListagem actions={actions} headers={headers} items={destinos} options={{ print: false, search: true, pagination: true }} title="Lista de destinos" />
                </div>
            </MainCard>
        </>
    )
}